(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    var SLEUTEL = 'mb-bewaard';

    function lees() {
      try {
        var lijst = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
        return Array.isArray(lijst) ? lijst : [];
      } catch (e) {
        return [];
      }
    }

    function schrijf(lijst) {
      try {
        localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
      } catch (e) {}
    }

    function variantVan(knop) {
      var form = knop.closest('form');
      var veld = form && form.querySelector('input[name="id"]');
      return veld ? String(veld.value) : '';
    }

    function zetStaat(knop) {
      var variant = variantVan(knop);
      var bewaard = !!variant && lees().some(function (r) { return String(r.variant) === variant; });
      var gewenst = bewaard ? 'true' : 'false';
      if (knop.getAttribute('aria-pressed') !== gewenst) knop.setAttribute('aria-pressed', gewenst);
      var tekst = knop.querySelector('.mb-bewaar-knop__tekst');
      var label = bewaard ? knop.dataset.labelBewaard : knop.dataset.labelBewaar;
      if (tekst && tekst.textContent !== label) tekst.textContent = label;
    }

    function syncAlles() {
      document.querySelectorAll('[data-mb-bewaar]').forEach(zetStaat);
    }

    document.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-mb-bewaar]');
      if (!knop || knop.disabled) return;
      e.preventDefault();
      var variant = variantVan(knop);
      if (!variant) return;
      var lijst = lees();
      var index = lijst.findIndex(function (r) { return String(r.variant) === variant; });
      var bewaard;
      if (index > -1) {
        lijst.splice(index, 1);
        bewaard = false;
      } else {
        lijst.push({
          variant: variant,
          product: knop.dataset.productId,
          handle: knop.dataset.productHandle,
          aantal: 1,
          tijd: new Date().toISOString()
        });
        bewaard = true;
      }
      schrijf(lijst);
      syncAlles();
      var status = knop.parentElement && knop.parentElement.querySelector('[data-mb-bewaar-status]');
      if (status) status.textContent = bewaard ? knop.dataset.labelBewaard : '';
      document.dispatchEvent(new CustomEvent('mb:bewaard', { detail: { variant: variant, bewaard: bewaard, aantal: lijst.length } }));
    });

    /* Bij het kiezen van een andere variant ververst het thema de sectie (morph). Daarbij komt de
       servertekst Bewaren terug en wijzigt de variant in het formulier: dan de staat opnieuw zetten. */
    var bezig = false;
    new MutationObserver(function (mutaties) {
      if (bezig) return;
      var relevant = mutaties.some(function (m) {
        var t = m.target;
        if (t.nodeType !== 1) t = t.parentElement;
        if (t && (t.matches('input[name="id"]') || t.closest('[data-mb-bewaar]'))) return true;
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('[data-mb-bewaar], input[name="id"]') || n.querySelector('[data-mb-bewaar]'));
        });
      });
      if (!relevant) return;
      bezig = true;
      syncAlles();
      setTimeout(function () { bezig = false; }, 0);
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['value', 'aria-pressed']
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAlles);
    } else {
      syncAlles();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
